import { Component, Host, h, Prop, Listen, Element } from '@stencil/core';
import { handleLinkClick, handleLinkKeydown } from '../../utils/utils';

@Component({
  tag: 'me-card',
  styleUrl: 'me-card.scss',
  shadow: false,
})
export class MeCard {

  @Element() host: HTMLElement;

  @Prop() theme?: string;
  @Prop() highlighted = false;
  @Prop() shadow = false;
  @Prop({ reflect: true }) href?: string;
  @Prop() target = '_self';

  @Listen('keydown')
  handleKeyDown(event: KeyboardEvent) {
    if (this.href) {
      handleLinkKeydown(event, this.host);
    }
  }

  @Listen('click')
  handleClick(event: MouseEvent) {
    if (this.href) {
      handleLinkClick(this.href, this.target, event)
    }
  }

  render() {
    const classList = [
      'me-card',
      this.theme ? `me-card--${this.theme}` : null,
      this.highlighted ? `me-card--highlighted` : null,
      this.shadow ? `me-card--shadow` : null,
      this.href ? `me-card--link` : null,
    ].filter(c => !!c).join(' ');

    return (
      <Host
        class={classList}
        role={this.href ? 'link' : null}
        tabindex={this.href ? '0' : null}
      >
        <div class="me-card__header">
          <slot name="header"></slot>
        </div>
        <div class="me-card__body">
          <div class="me-card__content">
            <slot />
          </div>
          <div class="me-card__icon-right">
            <slot name="icon-right" />
          </div>
        </div>
        <div class="me-card__footer">
          <slot name="footer"></slot>
        </div>
        <div class="me-card__chip">
          <slot name="chip"></slot>
        </div>
      </Host>
    );
  }
}
